import { Card, CardContent, CardHeader, Link, Paper, Stack } from "@mui/material";
import DownloadIcon from '@mui/icons-material/Download';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
const prefix = process.env.REACT_APP_PREFIX;

const LinksDash = () => {
    return <Paper><Card>
        <CardHeader title="Links" titleTypographyProps={{variant: "h2"}} subheader="" />
        <CardContent>
            {
                prefix.includes("main") ?<Stack direction="column">
                    <Link href="https://2158abd7cb7b4020b0136cdb389ebb53.eastus2.azure.elastic-cloud.com:9243/app/dashboards#/view/e3f8e250-286c-11eb-b180-038236849305?_g=(filters:!())&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),tags:!(),timeRestore:!t,title:Default,viewMode:view)">ElasticSearch</Link>
                    <Link href="https://leftcoastoriginal.com/" sx={{display:"flex"}} underline="none"><OpenInNewIcon display="flex" sx={{marginRight: 1}} />Left Coast Original</Link>
                    <Link href="https://xoq.app/downloads/exoqueue_installer.exe" sx={{display:"flex"}} underline="none"><DownloadIcon display="flex" sx={{marginRight: 1}} />Windows Client</Link>
                    <Link href="https://xoq.app/downloads/ExoQueue-silicon.zip" sx={{display:"flex"}} underline="none"><DownloadIcon display="flex" sx={{marginRight: 1}} />Mac Client (Apple Silicon)</Link>
                    </Stack> : <></>
            }
            {
                prefix.includes("lcc") ? <Stack direction="column">
                    <Link href="https://leftcoastcabinets.com/" sx={{display:"flex"}} underline="none"><OpenInNewIcon display="flex" sx={{marginRight: 1}} />Left Coast Cabinets</Link>
                    <Link href="https://xoq.app/downloads/exoqueue_installer.exe" sx={{display:"flex"}} underline="none"><DownloadIcon display="flex" sx={{marginRight: 1}} />Windows Client</Link>
                    <Link href="https://xoq.app/downloads/ExoCabinet-silicon.zip" sx={{display:"flex"}} underline="none"><DownloadIcon display="flex" sx={{marginRight: 1}} />Mac Client (Apple Silicon)</Link>
                    </Stack> : <></>
            }
        </CardContent>
        </Card></Paper>
}

export { LinksDash };